'use strict';

module.exports = {
    getUrl: Odigeo._.constant('getsubscriptionoffer'),

    getMethod: Odigeo._.constant('GET'),

    requestSuccess(data) {
        Odigeo.trigger(`${this.widget.id}:getSubscriptionOfferOk`, data);
    },

    requestError: Odigeo._.noop,
};
